import React from "react";
import Cookies from "js-cookie";

const translations = {
  en: "1930-Cyber Bot",
  Hi: "1930-साइबर बॉट",
  Kn: "1930-ಸೈಬರ್ ಬಾಟ್",
};
export default function Header() {
   const selectedLang = Cookies.get('selectedLanguage') || 'en';
  return (
    <header> 
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",      
        }}
      >
        <img src="\images\login_logo_ka_bot.jpeg" alt="Cyber Bot Logo" className="csi-logos" />
        <h1 className="header-title"  >
        {translations[selectedLang]}
        </h1>
        {/* <img src="\images\logoRight.jpg" alt="csb-ts" className="csi-logo2" /> */}
        <div style={{ width: "50px" }}></div>
      </div>
    </header>
  );
}
